import React from 'react';
import { Section } from '../ui/Section';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'BONUS #1',
    name: 'Manual de Defensa Mental Avanzada',
    desc: 'Técnicas avanzadas para proteger tu psicología de ataques y manipulación.',
    image: 'https://cdn.magicpatterns.com/uploads/77pMo8E7UAddv4R2mWn278/ChatGPT_Image_23_feb_2026,_14_30_59.png'
  }, {
    title: 'BONUS #2',
    name: 'Carisma y Presencia Imparable',
    desc: 'Cómo proyectar autoridad magnética sin decir una sola palabra.',
    image: 'https://cdn.magicpatterns.com/uploads/wfdwBKZz9Vg7pCPCZ9MxuD/ChatGPT_Image_23_feb_2026,_14_31_10.png'
  }, {
    title: 'BONUS #3',
    name: 'Cómo Leer Mentiras en Pareja y Trabajo',
    desc: 'Guía rápida de bolsillo para leer señales de engaño en tiempo real.',
    image: 'https://cdn.magicpatterns.com/uploads/1K8EAeyDVLwkSVVdri5rpH/ChatGPT_Image_23_feb_2026,_14_31_18.png'
  }];
  return <Section className="bg-zinc-900" data-id="element-27">
      <div className="text-center mb-12" data-id="element-28">
        <span className="bg-red-600 text-white px-3 py-1 rounded text-xs font-bold uppercase tracking-wider mb-4 inline-block animate-pulse" data-id="element-29">
          Gratis por hoy
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-30">
          Regalos Exclusivos
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-31">
        {bonuses.map((bonus, i) => <div key={i} className="bg-black border border-zinc-800 rounded-xl overflow-hidden group hover:border-yellow-500/40 transition-colors" data-id="element-32">
            <div className="relative overflow-hidden" data-id="element-33">
              <img src={bonus.image} alt={bonus.name} className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-500" data-id="element-34" />
              <div className="absolute top-3 left-3" data-id="element-35">
                <span className="bg-yellow-500 text-black text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-36">
                  {bonus.title}
                </span>
              </div>
            </div>
            <div className="p-6 relative z-10" data-id="element-37">
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-38">
                {bonus.name}
              </h3>
              <p className="text-zinc-400 text-sm" data-id="element-39">{bonus.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}